/* @ngInject */
const myAreaChart = () => {
  return {
    restrict: 'E',
    scope: {
      myAreas: '=',
    },
    template: require('./myAreaChart.html'),

    /* @ngInject */
    controller: ($scope, $filter) => {
      $scope.areaPieLabels = ['Longueur utilisée (m)', 'Longueur restante (m)',]
      $scope.areaPieColors = ['#888888', '#ed9711',]
      $scope.areaPieData = []

      $scope.areasPieData = []
      $scope.areasPieLabels = []
      $scope.areasPieColors = []

      const colors = [
        '#ef9700',
        '#ec9222',
        '#eb8744',
        '#ea8266',
        '#e97788',
        '#e872aa',
        '#e767bb',
        '#e662cc',
      ]

      $scope.$watch('myAreas', (current, old) => {
        if (current === old) return
        if (!current) return

        const realAreas = current.filter(area => area.isReal)
        const usedLength = realAreas.reduce((total, area) => {
          return total + area.usedLength
        }, 0)
        const availableLength = realAreas.reduce((total, area) => {
          return total + area.availableLength
        }, 0)
        $scope.areaPieData = [
          Math.round(usedLength, 2),
          Math.round(availableLength, 2),
        ]

        const areasUsed = realAreas.map(area => area.usedLength)
        const areasAvailable = realAreas.map(area => area.availableLength)
        const areasNames = realAreas.map(area => area.name)

        for (let index = 0; index < areasUsed.length; index++) {
          const used = areasUsed[index]
          const available = areasAvailable[index]
          const name = areasNames[index]
          const color = colors[index]

          $scope.areasPieData.push(Math.round(used, 2))
          $scope.areasPieData.push(Math.round(available, 2))
          $scope.areasPieLabels.push(`${name} utilisée`)
          $scope.areasPieLabels.push(`${name} disponible`)
          $scope.areasPieColors.push('#888888')
          $scope.areasPieColors.push(color)
        }
      })

      function shadeColor(color, percent) {

        var R = parseInt(color.substring(1, 3), 16);
        var G = parseInt(color.substring(3, 5), 16);
        var B = parseInt(color.substring(5, 7), 16);

        R = parseInt(R * (100 + percent) / 100);
        G = parseInt(G * (100 + percent) / 100);
        B = parseInt(B * (100 + percent) / 100);

        R = (R < 255) ? R : 255;
        G = (G < 255) ? G : 255;
        B = (B < 255) ? B : 255;

        var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
        var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
        var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

        return "#" + RR + GG + BB;
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}

export default myAreaChart



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/directives/display/myAreaChart.js